import "./banner/Banner.css";
import React, { useState } from "react";
import Banner from "./banner/Banner";
import Demo_Product from "./demo_product/Demo_Product";
import All_Time_Fav from "./all_time_fav/All_Time_Fav";
import Product_vdo_preview from "./product_vdo_preview/Product_vdo_preview";
import Farming_on_purpose from "./farming_on_purpose/Farming_on_purpose";
import Farm_vdo from "./farm_vdo/Farm_vdo";
import Harvested_By_you from "./harvested_by_you/Harvested_By_you";
import Our_philosophy from "./our_philosophy/Our_philosophy";
import Explore_our_fresh_produce from "./explore_our_fresh_produce/Explore_our_fresh_produce";
import Philosophy_grounded_in_nature from "./philosophy_grounded_in_nature/Philosophy_grounded_in_nature";
import Testimonials from "./testimonials/Testimonials";
import Food_and_wellness_journal from "./food_and_wellness_journal/Food_and_wellness_journal";
import Stay_Connected from "./stay_Connected/Stay_Connected";
import Category_section from "./category-section/Category_section";
import { useDispatch, useSelector } from "react-redux";
import { AllShape, getAllCategories } from "../../features/master/masterSlice";
import { useEffect } from "react";
import {
  getAllOfferedProduct,
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import {
  getAddBanner,
  getHomeBanner,
  getHomeShopAndWatch,
  getStoreBanners,
} from "../../features/home/homeSlice";
import Demo_ProductCategory from "./demo_product/Demo_ProductCategory";
import { getAboutUs } from "../../features/aboutus/aboutusSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageSwipper from "./image_swipper/Image_Swipper";
import Shop_By_Shape from "./shop_by_shape/Shop_By_Shape";
import Reels from "./reels/Reels";
import SearchNow from "./search_now/SearchNow";
import GetExpertAdvice from "./get_expert_advice/GetExpertAdvice";
import CategorySwiper from "./categories_swiper/CategorySwiper";
import HealthcareProducts from "./healthcare_products/HealthcareProducts";
import HealthcareProductsSub from "./healthcare_products_sub/HealthcareProductsSub";
import BabycareProducts from "./babycare_products/BabycareProducts";
import BestHealthDeals from "./BestHealthDeals/BestHealthDeals";
import FeaturedProductsTabs from "./featured_products_tabs/FeaturedProductsTabs";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../utils/common";

function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  AOS.init({ disable: "mobile" });

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const banner = useSelector((state) => state.home.banners);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  const about_us = useSelector((state) => state.aboutus.about_us);

  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const shapes = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  const storeBanners = useSelector((state) => state.home.storeBanners);

  useEffect(() => {
    dispatch(getStoreBanners());
  }, [dispatch]);

  const addBanners = useSelector((state) => state.home.addBanners);

  useEffect(() => {
    dispatch(getAddBanner());
  }, [dispatch]);

  const catsBreakPoints = {
    320: { slidesPerView: 2 },
    450: { slidesPerView: 2.5 },
    575: { slidesPerView: 3 },
    768: { slidesPerView: 4 },
    992: { slidesPerView: 6 },
    1200: { slidesPerView: 7 },
  };

  const navigate = useNavigate();

  const handleCategoryCardClick = (id) => {
    navigate(`/categories?category_id=${encodeId(id)}`);
  };

  const OfferedProducts = useSelector((state) => state.product.OfferedProducts);

  useEffect(() => {
    dispatch(getAllOfferedProduct());
  }, [dispatch]);

  const allProductsGroup = useSelector(
    (state) => state.product.allProductsGroup,
  );

  useEffect(() => {
    dispatch(getGroupByProduct({}));
  }, [dispatch]);

  return (
    <>
      <Banner banner={banner} />
      <SearchNow />
      <Category_section />
      <GetExpertAdvice />
      <CategorySwiper
        showViewAll
        breakpoints={catsBreakPoints}
        data={category}
        showTitle={"Categories"}
        handleCategoryCardClick={handleCategoryCardClick}
      />
      {/* <Shop_By_Shape shapes={shapes} setShapeId={setShapeId} /> */}
      {/* <ImageSwipper/> */}
      {/* <div className="home_Demo_Product_holder">
        <Demo_ProductCategory products={category} breakpoints={breakpoints} />
      </div> */}
      <Product_vdo_preview about_us={about_us} />
      <All_Time_Fav products={OfferedProducts} />

      {allProductsGroup?.map((category) => (
        <HealthcareProducts
          key={category?.id}
          products={category?.Products || []}
          name={category?.name}
        />
      ))}
      <HealthcareProductsSub banners={storeBanners} />
      {/* <BabycareProducts products={productdata} /> */}
      <BestHealthDeals banners={addBanners} />
      <FeaturedProductsTabs />

      {/* <Farming_on_purpose /> */}
      {/* <Farm_vdo about_us={about_us} /> */}
      {/* <Harvested_By_you  /> */}
      {/* <Harvested_By_you products={category} /> */}
      {/* <Our_philosophy /> */}
      {/* <Explore_our_fresh_produce /> */}
      {/* <Philosophy_grounded_in_nature /> */}
      {/* <Testimonials /> */}
      {/* <Food_and_wellness_journal /> */}
      {/* <Stay_Connected /> */}

      {/* {watch_and_shop?.length > 0 && <Reels watch_and_shop={watch_and_shop} />} */}
    </>
  );
}

export default Home;
